import Phaser from "phaser";
import { DESIGN_HEIGHT, DESIGN_WIDTH, COLORS } from "./constants";
import { EncounterScene } from "./scenes/EncounterScene";
import { OverworldScene } from "./scenes/OverworldScene";
import { RunHudScene } from "./scenes/RunHudScene";
import { MainMenuScene } from "./scenes/MainMenuScene";

export const createGameConfig = (parent: string): Phaser.Types.Core.GameConfig => ({
  type: Phaser.AUTO,
  width: DESIGN_WIDTH,
  height: DESIGN_HEIGHT,
  parent,
  backgroundColor: COLORS.background,
  banner: false,
  // Note: first scene in this list will auto-start.
  scene: [MainMenuScene, EncounterScene, OverworldScene, RunHudScene],
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: DESIGN_WIDTH,
    height: DESIGN_HEIGHT,
    expandParent: false,
  },
  callbacks: {
    postBoot: (game: Phaser.Game) => {
      const refreshScale = () => game.scale.refresh();
      window.addEventListener("resize", refreshScale);
      game.events.once(Phaser.Core.Events.DESTROY, () => {
        window.removeEventListener("resize", refreshScale);
      });
    },
  },
  physics: {
    default: "arcade",
    arcade: {
      debug: false,
    },
  },
  render: {
    antialias: true,
    roundPixels: false,
    pixelArt: false,
  },
});
